import { render, staticRenderFns } from "./ByMnemonicContainer.vue?vue&type=template&id=64dda4e6&scoped=true&"
import script from "./ByMnemonicContainer.vue?vue&type=script&lang=js&"
export * from "./ByMnemonicContainer.vue?vue&type=script&lang=js&"
import style0 from "./ByMnemonicContainer.vue?vue&type=style&index=0&id=64dda4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dda4e6",
  null
  
)

export default component.exports